import { useTranslation } from 'react-i18next';
import { PageHeader } from 'shared/components/PageHeader';

export function EpisodesHeaderSection() {
  const { t } = useTranslation('episodes');

  return (
    <header className="mb-10 md:mb-20 max-w-2xl">
      <PageHeader
        label={t('header.label')}
        title={t('header.heading')}
        titleHighlight={t('header.headingHighlight')}
        description={t('header.description')}
      />
    </header>
  );
}
